const table = {
  styleOverrides: {
    root: {
      borderCollapse: "collapse",
      width: "100%",
    },
  },
};

export default table;
